<form [formGroup]="emailQrcodeForm" (ngSubmit)="onSubmit()" class="qr-email">
  <div class="xr-dialog-header qr-email__header">
    <h2 class="qr-email__title">{{ 'technicians_page.email_title' | translate }}</h2>
    <button type="button" class="xr-btn xr-btn--soft xr-btn--icon" (click)="closeModal()"
            [attr.aria-label]="'technicians_page.close' | translate"
            [matTooltip]="'technicians_page.close' | translate">
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
  </div>

  <mat-dialog-content class="mat-typography qr-email__content">
    <p class="qr-email__intro">
      {{ 'technicians_page.email_intro' | translate: { email: data?.technician_email } }}
    </p>

    <label class="qr-email__label" for="qr-email-cc">{{ 'technicians_page.email_cc_label' | translate }}</label>
    <mat-form-field appearance="outline" class="w-100 hide-hint">
      <mat-chip-grid #chipGrid [attr.aria-label]="'technicians_page.email_cc_label' | translate">
        @for (email of emailQrcodeForm.get('ccEmails')?.value; track email){
        <mat-chip-row
          (removed)="remove(email)">
          {{ email }}
          <button type="button" matChipRemove [attr.aria-label]="'technicians_page.email_remove' | translate: { email: email }">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
        }
      </mat-chip-grid>
      <input matInput
             id="qr-email-cc"
             [placeholder]="'technicians.insert_email' | translate"
             [formControl]="newEmailCtrl"
             [matChipInputFor]="chipGrid"
             [matChipInputAddOnBlur]="true"
             [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
             (matChipInputTokenEnd)="add($event)" />
      <mat-error *ngIf="newEmailCtrl.hasError('email') && (newEmailCtrl.touched || newEmailCtrl.dirty)">
        {{ 'login.invalid_email' | translate }}
      </mat-error>

      <mat-error *ngIf="newEmailCtrl.hasError('invalidEmailFormat') && (newEmailCtrl.touched || newEmailCtrl.dirty)">
        {{ 'technicians_page.email_invalid_format' | translate }}
      </mat-error>
    </mat-form-field>
    <p class="qr-email__hint">{{ 'technicians.send_qrcode_info' | translate }}</p>
  </mat-dialog-content>

  <mat-dialog-actions class="xr-dialog-actions qr-email__actions">
    <button type="button" class="xr-btn xr-btn--secondary" (click)="closeModal()">
      {{ 'technicians_page.cancel' | translate }}
    </button>
    <button type="submit" class="xr-btn xr-btn--primary" [disabled]="emailQrcodeForm.invalid">
      <i-tabler name="send-2" class="icon-18 d-flex" aria-hidden="true"></i-tabler>
      {{ 'technicians_page.email_send' | translate }}
    </button>
  </mat-dialog-actions>
</form>
